import styled from "styled-components";

export const ButtonAction = styled.button`
  margin-right: 5px;
  color: ${({ $isDelete }) => ($isDelete ? "#d6475f" : "#6ec1e4")};
  font-size: 1rem;
  border: 0px;
  background: transparent;
  width: max-content;
  height: 30px;
  width: 30px;

  &:hover {
    color: #fff;
    font-size: 1rem;
    background: ${({ $isDelete }) => ($isDelete ? "#d6475f" : "#6ec1e4")};
    border-radius: 30px;
  }
`;

export const Icon = styled.i`
  margin-right: 10px;
`;

export const Option = styled.li`
  padding: 10px;
`;

export const ListOptions = styled.ul`
  background: #203b34;
`;

export const ButtonClose = styled.button`
  font-size: 1rem;
  border: 0px;
  background: transparent;
`;

export const EditButton = styled.button`
  border: 0px;
  background-color: #6ec1e4;
  color: #fff;
  border-radius: 5px;
  font-size: 1rem;
  height: 35px;
  width: 35px;

  &:hover {
    background-color: #63accc;
  }
`;

export const DeleteButton = styled.button`
  border: 0px;
  background-color: #d6475f;
  color: #fff;
  border-radius: 5px;
  font-size: 1rem;
  height: 35px;
  width: 35px;

  &:hover {
    background-color: #e94c66;
  }
`;
